import React, { useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';

import {
    LinearProgress,
    Grid,
    Container
} from '@material-ui/core';

import {
    PageHeader
} from '../../../common';

import {
    RoleDetails
} from './components';

import { PageProvider, PageContext } from './PageContext';
import { NavContext, NavRoutes } from '../../../contexts';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    container: {
        marginTop: theme.spacing(2)
    }
}));

const PageContent = (props) => {
    const classes = useStyles();

    const {
        state,
        pageIsReady,
        setPageIsReady,
        isBusy,
        setIsBusy,
        getRoleAsync
    } = useContext(PageContext);

    const {
        navigateTo
    } = useContext(NavContext);

    const {
        role
    } = state;

    const manageUsersClick = (e) => {
        navigateTo(NavRoutes.Admin.RoleUsers, [role.applicationRoleId]);
    }

    const { roleId } = useParams();
    useEffect(() => {
        if (roleId) {
            getRoleAsync(parseInt(roleId));
        }
    }, [roleId]);

    useEffect(() => {
        setPageIsReady(role !== null)
    }, [role])

    return (
        <>
            {pageIsReady ?
                <Grid container spacing={3} className={classes.root}>
                    <Grid item xs={12}>
                        <PageHeader
                            action1
                            action1ButtonText="Manage users"
                            onAction1Click={manageUsersClick}
                            title={role.groupName}
                            subtitle="Role group details"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Container maxWidth="lg" className={classes.container}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <RoleDetails />
                                </Grid>
                            </Grid>
                        </Container>
                    </Grid>
                </Grid>
                :
                <LinearProgress />
            }
        </>
    );
}

export const RolePage = () => {

    return (
        <PageProvider>
            <PageContent />
        </PageProvider>
    );
}